var map = {
	"./ar/actions.js": 85,
	"./ar/errors.js": 86,
	"./ar/global.js": 87,
	"./ar/header.js": 88,
	"./ar/labels.js": 89,
	"./de/actions.js": 90,
	"./de/errors.js": 91,
	"./de/global.js": 92,
	"./de/header.js": 93,
	"./de/labels.js": 94,
	"./de/license.js": 95,
	"./de/placeholders.js": 96,
	"./el/actions.js": 97,
	"./el/errors.js": 98,
	"./el/global.js": 99,
	"./el/header.js": 100,
	"./el/labels.js": 101,
	"./en/actions.js": 102,
	"./en/errors.js": 103,
	"./en/global.js": 104,
	"./en/header.js": 105,
	"./en/labels.js": 106,
	"./en/license.js": 107,
	"./en/placeholders.js": 108,
	"./es/actions.js": 109,
	"./es/errors.js": 110,
	"./es/global.js": 111,
	"./es/header.js": 112,
	"./es/labels.js": 113,
	"./fa/actions.js": 114,
	"./fa/errors.js": 115,
	"./fa/global.js": 116,
	"./fa/header.js": 117,
	"./fa/labels.js": 118,
	"./hi/actions.js": 119,
	"./hi/errors.js": 120,
	"./hi/global.js": 121,
	"./hi/header.js": 122,
	"./hi/labels.js": 123,
	"./it/actions.js": 124,
	"./it/errors.js": 125,
	"./it/global.js": 126,
	"./it/header.js": 127,
	"./it/labels.js": 128,
	"./ja/actions.js": 129,
	"./ja/errors.js": 130,
	"./ja/global.js": 131,
	"./ja/header.js": 132,
	"./ja/labels.js": 133,
	"./ko/actions.js": 134,
	"./ko/errors.js": 135,
	"./ko/global.js": 136,
	"./ko/header.js": 137,
	"./ko/labels.js": 138,
	"./nl/actions.js": 139,
	"./nl/errors.js": 140,
	"./nl/global.js": 141,
	"./nl/header.js": 142,
	"./nl/labels.js": 143,
	"./pl/actions.js": 144,
	"./pl/errors.js": 145,
	"./pl/global.js": 146,
	"./pl/header.js": 147,
	"./pl/labels.js": 148,
	"./pt/actions.js": 149,
	"./pt/errors.js": 150,
	"./pt/global.js": 151,
	"./pt/header.js": 152,
	"./pt/labels.js": 153,
	"./tr/actions.js": 154,
	"./tr/errors.js": 155,
	"./tr/global.js": 156,
	"./tr/header.js": 157,
	"./tr/labels.js": 158,
	"./zh/actions.js": 159,
	"./zh/errors.js": 160,
	"./zh/global.js": 161,
	"./zh/header.js": 162,
	"./zh/labels.js": 163
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;


//////////////////
// WEBPACK FOOTER
// ./src/lang \.js$
// module id = 76
// module chunks = 35